enum UserTypes {
  CUSTOMER = "customer",
  AGENT = "agent",
  AGENT_BRANCH = "agentBranch",
  AGENT_PARTNER = "agentBusinessPartner",
  CHANNEL_PARTNER = "cpartner",
}

export default UserTypes;
